import hllUA from '@hll/user-agent';
import { getQueryString }  from '@hll/eapp-utils';
import { EP_H5_OS, EP_HARMONY_OS, EP_WXA_OS } from '@/constant';
import { myConsole } from '@/services/watch-dog';

const {
  is_hll_user_app,
  is_hll_euser_app,
  isHarmony: isHarmonyAlias,
  isAndroid: isAndroidAlias,
  isIOS: isIOSAlias,
  isPC: isPCAlias,
  isInWeixinApp: isInWeixinAppAlias,
  isInWeixinMini: isInWeixinMiniAlias,
  appRevision: appRevisionAlias, // 客户端版本号（4位数）
  appVersion: appVersionAlias, // 客户端版本号（x.y.z 字符串）	
} = hllUA.parse();

/**
 * 系统环境判断
 */
// android
export const isAndroid = isAndroidAlias;
// ios
export const isIOS = isIOSAlias;
// pc
export const isPC = isPCAlias;
// 鸿蒙
export const isHarmony = isHarmonyAlias;


/**
 * 小程序环境判断
 */
// 微信小程序
export const isInWeixinMini = isInWeixinMiniAlias;
// 微信内
export const isInWeixinApp = isInWeixinAppAlias;


/**
 * 货拉拉端判断
 */
// 企业端app(注意：android、ios、鸿蒙端)
export const isEpApp = is_hll_euser_app;
// 企业端android
export const isEpAndroidApp = isAndroid && isEpApp;
// 企业端ios
export const isEpIOSApp = isIOS && isEpApp;
// 企业鸿蒙app端
export const isEpHarmonyApp = isHarmony && isEpApp;
// 用户端app(ios端、android端、已兼容鸿蒙端)
export const isHllUserApp = is_hll_user_app;
// 用户鸿蒙app端
export const isUserHarmonyApp = isHarmony && isHllUserApp;

// 企业鸿蒙h5端
export const isEpHarmonyH5 = (() => {

  if (!isEpHarmonyApp) {
    return false;
  }

  // url 判断
  if (getQueryString('ep_from') === EP_HARMONY_OS) {
    sessionStorage.setItem('epFrom', EP_HARMONY_OS);
    return true;
  }

  // sessionStorage 判断
  if (sessionStorage.getItem('epFrom') === EP_HARMONY_OS) {
    return true;
  }

  return false;

})();

// 小Bh5端
export const isEpUserH5 = (() => {
  if (!isHllUserApp) {
    return false;
  }

  // url 判断
  if (getQueryString('ep_from') === EP_H5_OS) {
    sessionStorage.setItem('epFrom', EP_H5_OS);
    return true;
  }
  // sessionStorage 判断
  if (sessionStorage.getItem('epFrom') === EP_H5_OS) {
    return true;
  }

  return false;

})();

// 版本号，客户端版本号（4位数）
export const appRevision = appRevisionAlias;
// 版本名，客户端版本号（x.y.z 字符串）
export const appVersion = appVersionAlias;

// 获取 OS 投放的端
export const apiOS = (() => {
  // 企业鸿蒙H5
  if (isEpHarmonyH5) {
    return EP_HARMONY_OS;
  }

  // 企业小Bh5
  if (isEpUserH5) {
    return EP_H5_OS;
  }

  const ua = getQueryString('ua');
  // 企业微信小程序
  if (ua === EP_WXA_OS) {
    return EP_WXA_OS;
  }

  // android
  if (isEpApp && isAndroid) {
    return 'android';
  }

  // ios
  if (isEpApp && isIOS) {
    return 'ios';
  }

  return '';
})();

// 用于线上测试观察，后续删除掉
(() => {
  const envInfo = {
    isAndroid,
    isIOS,
    isPC,
    isHarmony,
    isInWeixinMini,
    isInWeixinApp,
    isEpApp,
    isEpAndroidApp,
    isEpIOSApp,
    isEpHarmonyApp,
    isHllUserApp,
    isUserHarmonyApp,
    isEpHarmonyH5,
    isEpUserH5,
    appRevision,
    appVersion,
    apiOS,
  };
  const envInfoFilter = {};
  Object.keys(envInfo).forEach(key => {
    if (envInfo[key] !== undefined) {
      envInfoFilter[key] = envInfo[key];
    }
  })
  myConsole.log('环境信息', envInfoFilter);
})();